var ItemCountOperation = /* @__PURE__ */ ((ItemCountOperation2) => {
  ItemCountOperation2["INCREASE"] = "increase";
  ItemCountOperation2["DECREASE"] = "decrease";
  return ItemCountOperation2;
})(ItemCountOperation || {});
export {
  ItemCountOperation
};
//# sourceMappingURL=types.js.map
